export default "__VITE_PUBLIC_ASSET__0b9f9e15__"